import { render, staticRenderFns } from "./productColumn.vue?vue&type=template&id=2195a174&scoped=true"
import script from "./productColumn.vue?vue&type=script&lang=js"
export * from "./productColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2195a174",
  null
  
)

export default component.exports